(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/widget-area.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/widget-area.js');
"use strict";

const {
  useEffect,
  useState
} = React;
const WidgetArea = _ref => {
  let {
    areaName,
    className,
    fallback = null
  } = _ref;
  const [content, setContent] = useState();
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    if (svs.core.widget_area && svs.core.widget_area.loadArea) {
      svs.core.widget_area.loadArea(areaName, content => {
        setContent(content);
        setIsReady(true);
      });
    } else {
      setIsReady(true);
    }
  }, [areaName]);
  if (content) {
    return React.createElement("div", {
      className: className,
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }
  return isReady && fallback;
};
setGlobal('svs.tickets_giftshop.gift.WidgetArea', WidgetArea);

 })(window);